/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Rights_Tools_Remove_Tool_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "This clears every subject's override for {tool}. Because this tool is not exposed by the connector, it disappears from the list until it is configured again." |
*
* @param {Rights_Tools_Remove_Tool_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_tool_confirm_description = /** @type {((inputs: Rights_Tools_Remove_Tool_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Tool_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Entfernt für ${i?.tool} die Ausnahmen aller Subjekte. Da dieses Tool nicht vom Connector bereitgestellt wird, verschwindet es aus der Liste, bis es erneut konfiguriert wird.`)
	return /** @type {LocalizedString} */ (`This clears every subject's override for ${i?.tool}. Because this tool is not exposed by the connector, it disappears from the list until it is configured again.`)
});